import { lazy } from 'react';

const loadModal = () =>
  import('../welcome/AddYourTeamModal.js').then((m) => ({ default: m.AddYourTeamModal }));

/** AddYourTeamModal, loaded on first use: its grid, file reader and upgrade dialog stay out of the shell's first load. */
export const LazyAddYourTeamModal = lazy(loadModal);

/**
 * Starts fetching the modal's code, so "Upload Excel sheet" opens the file picker while the click
 * still counts as the person's own (browsers only open a picker from a recent tap or click).
 */
export function preloadAddTeamModal(): void {
  void loadModal();
}
